<template>
  <nav
    class="flex-shrink-0 w-56 mr-6 overflow-hidden bg-white border rounded border-ricoma-gray-300"
  >
    <ul>
      <li
        v-for="(serie, index) in series"
        :key="`serie-${index}`"
        class="flex items-center justify-between px-3 py-4 cursor-pointer"
        :class="[
          serie.name === selectedSerie.name
            ? 'bg-ricoma-orange-100 text-white font-semibold hover:bg-ricoma-orange-200'
            : 'text-ricoma-gray-600 hover:bg-ricoma-gray-100',
        ]"
        @click="handleSelect(serie)"
      >
        {{ serie.name }}
        <VSvgIcon name="chevron-right" />
      </li>
    </ul>
  </nav>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'SeriesSidebar',
  components: { VSvgIcon },
  props: {
    series: {
      type: Array,
      required: false,
      default: () => ({}),
    },
    selectedSerie: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods: {
    async handleSelect(serie) {
      this.$emit('select', serie);
    },
  },
};
</script>
